import React, { useContext } from "react";
import classes from "./Layout.module.scss";
import MainNav from "../Navs/MainNav";
import ScrollToTop from "../../components/ScrollToTop";
import WaterMarkProbrain from "../../components/WaterMarkProbrain";
import UserTrainingContext from "../../context/userTrainingContext";
import LoginBanner from "../../containers/LoginBanner";
import Footer from "../../components/Footer";
import SessionContext from "../../context/sessionContext";
import Dashboard from "../../components/Dashboard/index";
interface Interface {
  children?: any;
  style?: {
    [propName: string]: any;
  };
  className?: string | null;
}
export default function Layout({
  children,
  style = {},
  className = "",
}: Interface) {
  const tContext = useContext(UserTrainingContext);
  const cSession = useContext(SessionContext);

  className += " " + classes.Layout;
  if (tContext.game_url) className += " " + classes.NoScroll;

  return (
    <div className={className + " " + classes.Layout}>
      <MainNav />
      {cSession.user?.registry && <Dashboard />}


      {/* <LoginBanner /> */}
      <div className={classes.InnerArea}>{children}</div>
      {cSession.is_session_active && (
        <Footer />
      )}
      <WaterMarkProbrain />
      <ScrollToTop />
    </div>
  );
}
